import get from 'lodash.get';
import merge from 'lodash.merge';
import defaultState from '@/store/modules/auctions/defaultState';
import AuctionsClient from '@/api/AuctionsClient';
import Auction from '@/models/Auction';
import featureFlagSlugs from '@/constants/featureFlagSlugs';

const moduleKey = 'BuyingOutstanding';

const extraState = {
  buyingFilters: [],
};

const mutations = {
  setBuyingFilters(state, filters) {
    state.buyingFilters = filters;
  },
};

const actions = {
  getBuyingOutstandingAuctions({
    commit,
    state,
  }) {
    try {
      commit('setLoading', true);
      return state.auctions;
    } catch (error) {
      throw new Error(error.message);
    } finally {
      commit('setLoading', false);
    }
  },
  async checkForOutstandingAuctions(
    {
      dispatch,
      commit,
    },
  ) {
    const auctions = await dispatch('fetchOutstandingAuctions');
    commit('setAuctions', {
      auctions,
      moduleKey,
    });
    await dispatch('setPagination', auctions.length);

    // eslint-disable-next-line vue/max-len
    const checkForOutstandingAuctionsInterval = parseInt(import.meta.env.VITE_OUTSTANDING_PAYMENT_AUCTIONS_TTL, 10) || 86400000;
    // Check again in 24 hours unless the user reloads the window - ETC
    setTimeout(() => {
      dispatch('checkForOutstandingAuctions');
    }, checkForOutstandingAuctionsInterval);

    return auctions;
  },
  setPagination({
    commit,
  }, numberOfAuctions) {
    commit('setPagination', {
      pagination: {
        count: numberOfAuctions,
        next: 0,
        prev: 0,
      },
      moduleKey,
    });
  },
  async fetchOutstandingAuctions({
    dispatch,
    rootGetters,
  }, params) {
    const forceAuctionsFinalize = await dispatch('getFlag', featureFlagSlugs.forceAuctionsFinalize, { root: true });
    let auctions = [];
    if (forceAuctionsFinalize) {
      const client = new AuctionsClient(rootGetters.currentUser);
      const response = await client.getOutstandingAuctions(params);
      auctions = get(response, 'data.data.auctions', []);
      auctions = auctions.map((auction) => new Auction(auction, rootGetters.currentUser));
    }
    return auctions;
  },
};

const getters = {
  outstandingAuctions: (state) => state.auctions,
  hasOutstandingAuctions: (state) => state.auctions.length > 0,
  isOutstandingAuction: (state) => (auctionId) => typeof state.auctions.find((auction) => auction.id === auctionId) !== 'undefined',
};

export default {
  state: () => merge({}, defaultState(), extraState),
  actions,
  mutations,
  getters,
};
